import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
// import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { loadGapiInsideDOM } from 'gapi-script';

import { SocialAuthService, FacebookLoginProvider, SocialUser } from '@abacritt/angularx-social-login';

declare var gapi: any;

@Component({
  selector: 'app-login-pelanggan',
  templateUrl: './login-pelanggan.component.html',
  styleUrls: ['./login-pelanggan.component.css']
})


export class LoginPelangganComponent implements OnInit {

  errorMessage: string = '';
  isLoading: boolean = false;
  googleSignInError: string | null = null;

  loginForm!: FormGroup;
  logForm!: FormGroup;

  submitted = false;

  isImageError = false;

  // Data pengguna
  userSocial: SocialUser | null = null;
  isLoggedIn: boolean = false;
  isPasswordVisible = false;


  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private authService: AuthService,

    private socialAuthService: SocialAuthService

  ) {
    this.initializeForms();
  }



  private initializeForms() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.logForm = this.fb.group({
      email :[],
      passlog: ['', [Validators.required]]
    });

  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }


  user: { name: string, email: string, photo: string, user_login: string, user_wa: string } | null = null;
  showLoginForm: boolean = true; // Menampilkan atau menyembunyikan form login


  ngOnInit(): void {
    const userName = localStorage.getItem('user_name');
    const userEmail = localStorage.getItem('user_email');
    const userPhoto = localStorage.getItem('user_photo');
    const userLogin = localStorage.getItem('user_login');
    const userWa = localStorage.getItem('user_wa');
    // console.log( userName +" "+ userEmail +" "+userPhoto +" "+userLogin);


    // Cek jika data pengguna ada
    if (userName && userEmail && userLogin) {
      this.user = { name: userName, email: userEmail, photo: userPhoto || '', user_login: userLogin, user_wa: userWa ||'' };
      this.showLoginForm = false; // Sembunyikan form login
      if (userLogin === 'whatsapp')
      {
        this.router.navigate(['/login-pelanggan/whatsapp']);
      }

    } else {
      this.router.navigate(['/login-pelanggan']); // Redirect ke halaman login jika data tidak ada
      this.showLoginForm = true;
    }


    const token = localStorage.getItem('authToken');
    if (token) {
      this.router.navigate(['/home']); // Redirect jika token ada
    }

    this.loadGoogleScript(); 
  }

    // Optional: Programmatic sign-in trigger
    private loadGoogleScript() {
      loadGapiInsideDOM().then(() => {
        gapi.load('auth2', () => {
          gapi.auth2.init({
            client_id: environment.googleClientId,
            cookiepolicy: 'single_host_origin',
          });
        });
      });
     }
  

  handleGoogleLogin() {
    const auth2 = gapi.auth2.getAuthInstance();
    auth2.signIn({
      prompt: 'consent',
      scope: 'openid email profile'
    }) // Memunculkan dialog untuk memilih akun
      .then((googleUser: any) => {
        // Memeriksa jika login berhasil
        if (googleUser) {
          // const profile = googleUser.getBasicProfile();
          const idToken = googleUser.getAuthResponse().id_token;
          // Jika perlu, bisa mengirim data ke server untuk proses login
          this.authService.loginWithGoogle(idToken).subscribe(
            (res) => {

              const dt = res.user;
                // Simpan data ke localStorage
                localStorage.setItem('authToken', idToken);  // Token untuk autentikasi
                localStorage.setItem('user_name', dt.nama);
                localStorage.setItem('user_email', dt.email);
                localStorage.setItem('user_photo', dt.foto);
                localStorage.setItem('user_login', 'google');
        
                // Menyimpan objek data pengguna untuk penggunaan lainnya
                localStorage.setItem('user_pelanggan', JSON.stringify({
                  name: dt.nama,
                  email: dt.emai,
                  photo: dt.foto
                }));

              // Redirect ke halaman utama setelah login sukses
              //window.location.href = '/home';

             // Dapatkan rute asal
              const redirectUrl = this.authService.getRedirectUrl() || '/home'; // Default ke /dashboard jika tidak ada rute asal
              window.location.href = redirectUrl;
         
            },
            (error) => {
              this.errorMessage = 'Failed to login with Google. Please try again.';
            }
          );
        } else {
          this.errorMessage = 'Google login was cancelled or failed. Please try again.';
        }
      })
      .catch((error: any) => {
        // Menangani jika pengguna membatalkan login atau terjadi kesalahan lainnya
        this.errorMessage = 'Google login was cancelled or failed. Please try again.';
      });
  }

  // =====================
  // Facebook Login
  // =====================
  loginWithFacebook(): void {
    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID)
      .then(fbUser => {   
      // Kirim token Facebook ke backend untuk divalidasi
      this.authService.loginWithFacebook(fbUser.authToken).subscribe({
        next: (res) => {
          const dt = res.user;
          // Simpan data ke localStorage
          localStorage.setItem('authToken', fbUser.authToken);  // Token untuk autentikasi
          localStorage.setItem('user_name', dt.nama);
          localStorage.setItem('user_email', dt.email);
          localStorage.setItem('user_photo', dt.foto);
          localStorage.setItem('user_login', 'facebook');
  
          // Menyimpan objek data pengguna untuk penggunaan lainnya
          localStorage.setItem('user_pelanggan', JSON.stringify({
            name: dt.nama,
            email: dt.emai,
            photo: dt.foto
          }));

          // Dapatkan rute asal
          const redirectUrl = this.authService.getRedirectUrl() || '/home'; // Default ke /dashboard jika tidak ada rute asal
          window.location.href = redirectUrl;
        },
        error: (err) => {
          console.error('Error login:', err);
        }
      });
    })
    .catch(err => {
      console.error('Error saat login Facebook:', err);
    });

  }


  handleImageError(event: Event) {
    this.isImageError = true;
    (event.target as HTMLImageElement).style.display = 'none'; // Sembunyikan elemen gambar jika gagal
  }

    // Fungsi untuk menampilkan email yang dimasking
    getMaskedEmail(email: string): string {
      if (!email) return '';
      const [localPart, domain] = email.split('@');
      const maskedLocalPart = localPart.substring(0, 2) + '******'; // Masking 2 huruf pertama
      return `${maskedLocalPart}@${domain}`;
    }


  logout2(event: Event): void {
    event.preventDefault();
  
  
    // Menghapus data sesi
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_photo');
    localStorage.removeItem('user_login');
    localStorage.removeItem('user_wa');
    window.location.reload();
  }

 // Safely get form control with null check
 getFormControl(form: FormGroup, controlName: string): AbstractControl | null {
  return form.get(controlName);
}


// Safely check if control has specific error
hasError(form: FormGroup, controlName: string, errorType: string): boolean {
  const control = this.getFormControl(form, controlName);
  return control ? (this.submitted && control.hasError(errorType)) : false;
}




onContinueWithEmail() {
  this.submitted = true;
  const emailControl = this.getFormControl(this.loginForm, 'email');
  
  if (emailControl && this.loginForm.valid) {
    // Logic for email authentication
    // console.log('Email:', emailControl.value);
    this.authService.cek_email(emailControl.value).subscribe({
      next: (res) => {
        if (res.exists)
        {
          const dt = res.user;
          const userName = dt.nama;
          const userEmail = dt.email;
          const userPhoto = dt.foto || '';
          const userLogin = dt.login_method;
          const userWa = dt.wa;

          // Cek jika data pengguna ada
          if (userName && userEmail && userLogin) {
            this.user = { name: userName, email: userEmail, photo: userPhoto || '', user_login: userLogin, user_wa: userWa ||'' };
            this.showLoginForm = false; // Sembunyikan form login
            if (userLogin != 'whatsapp')
            {
              this.router.navigate(['/login-pelanggan']);           
            }else{

              localStorage.setItem('user_name', dt.nama);
              localStorage.setItem('user_email', dt.email);
              localStorage.setItem('user_photo', dt.foto || '');
              localStorage.setItem('user_wa', dt.whatsapp_number);
              localStorage.setItem('user_login', 'whatsapp');
                        
              this.router.navigate(['/login-pelanggan/whatsapp']); 
            }
          } else {
            this.router.navigate(['/login-pelanggan']); // Redirect ke halaman login jika data tidak ada
            this.showLoginForm = true;
          }
         
        }else {
          const email = emailControl.value;
          this.router.navigate(['/signup-pelanggan'], { queryParams: { email } });
        }

      },
        error: (err) => {
          console.error('Error login:', err);
        }
      });  
  }
}


masuk(){
  this.submitted = true;
   // Cek jika form tidak valid
   if (this.logForm.invalid) {
    return;
  }

  this.isLoading = true;
  
  const userEmail = this.user?.email;

  if (userEmail) {
    this.logForm.patchValue({
      email: userEmail // Nilai baru untuk email
    });
  }

  const loginData = {
    email: this.logForm.value.email,
    password: this.logForm.value.passlog
  };

  this.authService.login_email(loginData).subscribe({
    next: (res) => {
      this.isLoading = false;


      const dt = res.user;
            
      // Simpan data ke localStorage
      localStorage.setItem('authToken', res.token);
      localStorage.setItem('user_name', dt.nama);
      localStorage.setItem('user_email', dt.email);
      localStorage.setItem('user_photo', dt.foto || '');
      localStorage.setItem('user_wa', dt.whatsapp_number);
      localStorage.setItem('user_login', 'email');
      
      // Menyimpan objek data pengguna untuk penggunaan lainnya
      localStorage.setItem('user_pelanggan', JSON.stringify({
        name: dt.nama,
        email: dt.email,
        photo: dt.foto
      }));
        // Dapatkan rute asal
        const redirectUrl = this.authService.getRedirectUrl() || '/home'; // Default ke /dashboard jika tidak ada rute asal
        window.location.href = redirectUrl;
        this.submitted = false;

    },
    error: (error) => {
      // Jika login gagal, simpan pesan error dari backend
      this.errorMessage = error.error?.message || 'Terjadi kesalahan.';
      this.isLoading = false;

    }
    });  
  }

}
